/**
 * RowExpander — the ▸ at the start of a table row that opens its detail
 * beneath it (docs/features/journey-visual-language/01_proposal.md §4, "Tab
 * content"). Collections are tables; a row's detail lives under its ▸, not
 * in a card of its own.
 */
import { ChevronRight } from "lucide-react";
import { cn } from "../primitives/utils";

export function RowExpander({
  isOpen,
  onToggle,
  label,
  controls,
}: {
  isOpen: boolean;
  onToggle: () => void;
  /** What it opens, for its accessible name: "Details of .01". */
  label: string;
  /** The id of the detail row it opens. */
  controls: string;
}) {
  return (
    <button
      type="button"
      aria-expanded={isOpen}
      aria-controls={isOpen ? controls : undefined}
      aria-label={label}
      onClick={onToggle}
      className="inline-flex size-6 items-center justify-center rounded-sm text-muted-foreground outline-none hover:bg-muted hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ChevronRight
        aria-hidden
        className={cn("size-4 transition-transform", isOpen && "rotate-90")}
      />
    </button>
  );
}
